import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const WavyLine = () => (
  <svg className="wavy-line" viewBox="0 0 1440 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M0 16.2085C0 16.2085 100 -5.7915 240 -5.7915C380 -5.7915 480 38.2085 720 16.2085C960 -5.7915 1200 -5.7915 1320 16.2085C1440 38.2085 1440 16.2085 1440 16.2085" 
      stroke="#542a84" 
      strokeWidth="2"
    />
  </svg>
);

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          {/* Section 1: Delivery Locations */}
          <div className="footer-column">
            <h4 className="footer-title">We deliver at</h4>
            <p className="footer-text">
              Hopes, Peelamedu, Sitra, Singanallur, Cheranmanagar
            </p>
          </div>

          {/* Section 2: Address */}
          <div className="footer-column">
            <h4 className="footer-title">Our Address</h4>
            <p className="footer-text">
              NO: 278, Villankurichi Road, Thanneerpandal, Coimbatore - 641004, Tamil Nadu, India
            </p>
          </div>

          {/* Section 3: Follow Us */}
          <div className="footer-column">
            <h4 className="footer-title">Follow Us</h4>
            <div className="social-icons">
              <a 
                href="https://www.instagram.com/toven_daily?igsh=MXBrZXc3dTlub2JtMA==" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.facebook.com/share/1acyPSg7Z1/" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a 
                href="https://youtube.com/@toven_daily?si=AySeiBh5lythDMx4" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
          
          {/* Section 4: Explore */}
          <div className="footer-column">
            <h4 className="footer-title">Explore</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact us</Link></li>
              <li><Link to="/TermsAndConditions">Terms and Conditions</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <WavyLine />
          <p className="copyright-text">
            All Rights @ 2025 <Link to="/">Toven</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
